export default "__VITE_ASSET__B5d_WehV__"